webpackJsonp([193174647905062],{

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FeesQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @media screen and (max-width: 768px) {\n    max-width: 100vw;\n  }\n'], ['\n  @media screen and (max-width: 768px) {\n    max-width: 100vw;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    div {\n      max-width: 100vw;\n      overflow-x: auto;\n    }\n  }\n\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n\n  table {\n    display: inline-table;\n    margin: 1rem;\n    min-width: 250px;\n    border-spacing: 0;\n    max-width: 90vw;\n    border: 1px solid rgba(33, 36, 87, 0.1);\n\n    @media screen and (max-width: 768px) {\n      margin: 1rem 0;\n    }\n\n    img {\n      display: inline;\n      width: 1.5rem;\n      margin-right: 0.5rem;\n    }\n\n    td,\n    th {\n      padding: 0.75rem 1rem;\n    }\n\n    thead {\n      color: white;\n\n      p {\n        margin: 0;\n      }\n\n      tr:nth-child(2) th {\n        background: #141534;\n        padding: 0.25rem 1rem;\n        position: unset;\n        top: initial;\n        z-index: -1;\n\n        text-align: center;\n      }\n\n      th {\n        box-shadow: 0 3px 5px rgba(33, 36, 87, 0.24);\n        background: ', ';\n        @media screen and (min-width: 768px) {\n          position: sticky;\n          top: 70px;\n        }\n\n        &[colspan=\'2\'] {\n          text-align: center;\n        }\n      }\n    }\n\n    td {\n      border-top: 1px solid rgba(33, 36, 87, 0.2);\n    }\n\n    tr {\n      &:nth-child(even) {\n        background: rgba(33, 36, 87, 0.1);\n      }\n    }\n  }\n'], ['\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    div {\n      max-width: 100vw;\n      overflow-x: auto;\n    }\n  }\n\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n\n  table {\n    display: inline-table;\n    margin: 1rem;\n    min-width: 250px;\n    border-spacing: 0;\n    max-width: 90vw;\n    border: 1px solid rgba(33, 36, 87, 0.1);\n\n    @media screen and (max-width: 768px) {\n      margin: 1rem 0;\n    }\n\n    img {\n      display: inline;\n      width: 1.5rem;\n      margin-right: 0.5rem;\n    }\n\n    td,\n    th {\n      padding: 0.75rem 1rem;\n    }\n\n    thead {\n      color: white;\n\n      p {\n        margin: 0;\n      }\n\n      tr:nth-child(2) th {\n        background: #141534;\n        padding: 0.25rem 1rem;\n        position: unset;\n        top: initial;\n        z-index: -1;\n\n        text-align: center;\n      }\n\n      th {\n        box-shadow: 0 3px 5px rgba(33, 36, 87, 0.24);\n        background: ', ';\n        @media screen and (min-width: 768px) {\n          position: sticky;\n          top: 70px;\n        }\n\n        &[colspan=\'2\'] {\n          text-align: center;\n        }\n      }\n    }\n\n    td {\n      border-top: 1px solid rgba(33, 36, 87, 0.2);\n    }\n\n    tr {\n      &:nth-child(even) {\n        background: rgba(33, 36, 87, 0.1);\n      }\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-left: ', ';\n  margin-top: ', ';\n\n  @media screen and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    margin: 0 ', ';\n    margin-top: 100px;\n  }\n'], ['\n  margin-left: ', ';\n  margin-top: ', ';\n\n  @media screen and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    margin: 0 ', ';\n    margin-top: 100px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  > div {\n    @media screen and (max-width: 768px) {\n      padding: 0 ', ';\n    }\n    @media screen and (min-width: 767px) {\n      padding-top: ', ';\n      position: sticky;\n      top: 50px;\n      height: 200px;\n    }\n  }\n'], ['\n  height: 100%;\n  > div {\n    @media screen and (max-width: 768px) {\n      padding: 0 ', ';\n    }\n    @media screen and (min-width: 767px) {\n      padding-top: ', ';\n      position: sticky;\n      top: 50px;\n      height: 200px;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: ', ' ', ' ', '\n    ', ';\n\n  @media screen and (max-width: 768px) {\n    padding: ', ' 0;\n  }\n'], ['\n  padding: ', ' ', ' ', '\n    ', ';\n\n  @media screen and (max-width: 768px) {\n    padding: ', ' 0;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n  padding-top: 2rem;\n  display: grid;\n  grid-template-columns: ', ' 1fr;\n  grid-gap: ', ';\n\n  @media screen and (max-width: 768px) {\n    grid-template-columns: 1fr;\n    padding: 1rem 0;\n  }\n'], ['\n  padding: ', ';\n  padding-top: 2rem;\n  display: grid;\n  grid-template-columns: ', ' 1fr;\n  grid-gap: ', ';\n\n  @media screen and (max-width: 768px) {\n    grid-template-columns: 1fr;\n    padding: 1rem 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(20);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(44);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _LayoutContainer = __webpack_require__(65);
	
	var _LayoutContainer2 = _interopRequireDefault(_LayoutContainer);
	
	var _Card = __webpack_require__(39);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardBody = __webpack_require__(55);
	
	var _CardBody2 = _interopRequireDefault(_CardBody);
	
	var _AnchorPills = __webpack_require__(145);
	
	var _AnchorPills2 = _interopRequireDefault(_AnchorPills);
	
	var _materialKitProReact = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeesTemplate = function (_Component) {
	  _inherits(FeesTemplate, _Component);
	
	  function FeesTemplate() {
	    _classCallCheck(this, FeesTemplate);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FeesTemplate.prototype.getActiveTab = function getActiveTab(tabs) {
	    var path = this.props.location.pathname;
	    var activeTab = void 0;
	    tabs.forEach(function (tab) {
	      if (path === tab.tabLink) {
	        activeTab = tab.i;
	      }
	    });
	    return activeTab;
	  };
	
	  FeesTemplate.prototype.render = function render() {
	    var page = this.props.data.page;
	    var tabs = this.props.data.settings.edges[0].node.frontmatter.feesOrder.map(function (tab, i) {
	      return {
	        tabButton: tab.title,
	        tabLink: tab.link,
	        i: i
	      };
	    });
	
	    return _react2.default.createElement(
	      _LayoutContainer2.default,
	      { background: 'linear-gradient(147deg, #efefef, #ffffff)' },
	      _react2.default.createElement(_reactHelmet2.default, { title: page.frontmatter.title }),
	      _react2.default.createElement(
	        DocumentationTitle,
	        null,
	        page.frontmatter.title
	      ),
	      _react2.default.createElement(
	        DocumentationContainer,
	        null,
	        _react2.default.createElement(
	          DocumentationNav,
	          null,
	          _react2.default.createElement(_AnchorPills2.default, {
	            leftAlign: true,
	            color: 'primary',
	            horizontal: true,
	            active: this.getActiveTab(tabs),
	            tabs: tabs
	          })
	        ),
	        _react2.default.createElement(
	          DocumentationCard,
	          { raised: true },
	          _react2.default.createElement(
	            DocumentationCardBody,
	            null,
	            _react2.default.createElement(InnerContainer, { dangerouslySetInnerHTML: { __html: page.html } })
	          )
	        )
	      )
	    );
	  };
	
	  return FeesTemplate;
	}(_react.Component);
	
	exports.default = FeesTemplate;
	
	
	var DocumentationCardBody = (0, _styledComponents2.default)(_CardBody2.default)(_templateObject);
	
	var InnerContainer = _styledComponents2.default.p(_templateObject2, _materialKitProReact.primaryColor, _materialKitProReact.primaryColor);
	
	var DocumentationTitle = _styledComponents2.default.h2(_templateObject3, function (p) {
	  return p.theme.col(4);
	}, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col();
	});
	
	var DocumentationNav = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col();
	});
	
	var DocumentationCard = (0, _styledComponents2.default)(_Card2.default)(_templateObject5, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col(2);
	}, function (p) {
	  return p.theme.col(2);
	}, function (p) {
	  return p.theme.col();
	});
	
	var DocumentationContainer = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col(2.5);
	}, function (p) {
	  return p.theme.col(0.5);
	});
	
	var FeesQuery = exports.FeesQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-fees-jsx-ecf1d9f5fd52ddf7c290.js